import pack from '../../package.json'

const IS_PROD = import.meta.env.MODE === 'prod'

const { name, version, 'test-version': test } = pack

/* eslint no-console: 0 */
console.log(
  `%c!${name.toLocaleUpperCase()}!`,
  'color: #fff; font-size: 48px; font-weight: 700; background-color: #00ADEF;'
)
console.log(
  // eslint-disable-next-line no-undef
  `%cEnv.: %c${import.meta.env.MODE.toUpperCase()}\n%cVer.: %c${version}${
    !IS_PROD ? `-${test}` : ''
  }`,
  'color: #4d5661; font-size: 12px;',
  'color: #D14343; font-weight: 700; font-size: 14px; background-color: #090C12;',
  'color: #4d5661; font-size: 12px;',
  'color: #FFB020; font-weight: 700; font-size: 14px; background-color: #090C12;'
)
